var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMissionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 292,
    viewBox: "0 0 170 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.629 218.571C165.861 211.427 170 203.133 170 194.286C170 167.46 131.944 145.714 85 145.714C38.0558 145.714 0 167.46 0 194.286C0 203.133 4.13926 211.427 11.3715 218.571C26.0684 204.053 53.538 194.286 85 194.286C116.462 194.286 143.932 204.053 158.629 218.571Z",
    fill: "url(#paint0_linear_3112_7439)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 242.857C131.944 242.857 170 221.111 170 194.286V242.857C170 269.682 131.944 291.429 85 291.429C38.0558 291.429 0 269.682 0 242.857V194.286C0 221.111 38.0558 242.857 85 242.857Z",
    fill: "url(#paint1_linear_3112_7439)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.629 145.714C165.861 138.57 170 130.276 170 121.429C170 94.6033 131.944 72.8572 85 72.8572C38.0558 72.8572 0 94.6033 0 121.429C0 130.276 4.13926 138.57 11.3715 145.714C26.0684 131.196 53.538 121.429 85 121.429C116.462 121.429 143.932 131.196 158.629 145.714Z",
    fill: "url(#paint2_linear_3112_7439)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85 170C131.944 170 170 148.254 170 121.429V170C170 196.825 131.944 218.571 85 218.571C38.0558 218.571 0 196.825 0 170V121.429C0 148.254 38.0558 170 85 170Z",
    fill: "url(#paint3_linear_3112_7439)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.629 72.8571C165.861 65.7129 170 57.4184 170 48.5714C170 21.7462 131.944 0 85 0C38.0558 0 0 21.7462 0 48.5714C0 57.4184 4.13926 65.7129 11.3715 72.8571C26.0684 58.3391 53.538 48.5714 85 48.5714C116.462 48.5714 143.932 58.3391 158.629 72.8571Z",
    fill: "url(#paint4_linear_3112_7439)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85 97.1429C131.944 97.1429 170 75.3967 170 48.5715V97.1429C170 123.968 131.944 145.714 85 145.714C38.0558 145.714 0 123.968 0 97.1429V48.5715C0 75.3967 38.0558 97.1429 85 97.1429Z",
    fill: "url(#paint5_linear_3112_7439)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3112_7439",
    x1: 85,
    y1: 145.714,
    x2: 85,
    y2: 212.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3112_7439",
    x1: 85,
    y1: 222.619,
    x2: 85,
    y2: 291.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3112_7439",
    x1: 85,
    y1: 72.8572,
    x2: 85,
    y2: 139.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3112_7439",
    x1: 85,
    y1: 149.762,
    x2: 85,
    y2: 218.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3112_7439",
    x1: 85,
    y1: 0,
    x2: 85,
    y2: 66.7857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3112_7439",
    x1: 85,
    y1: 76.9048,
    x2: 85,
    y2: 145.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565656"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionIcon);
export default __webpack_public_path__ + "static/media/mission_icon.454e119ab5f63da447209ebe61a39e62.svg";
export { ForwardRef as ReactComponent };